export const NOVA_SUCCESS_STORY_SOURCE = "nova";

export interface TransformationStoryCoachLink {
  username: string;
  coachName: string;
}

export interface PublicTransformationStory {
  id: string;
  name: string;
  avatarUrl: string | null;
  body: string;
  source: string;
  summitSessionId: string | null;
  createdAt: Date;
  updatedAt: Date;
  /** Present only while the workshop's coach has a public claimed profile. */
  workshopCoach: {
    username: string;
    coachName: string;
    sessionTitle: string;
  } | null;
  /** Present only while the story's linked coach has a public claimed profile. */
  profileCoach: TransformationStoryCoachLink | null;
}
